const en = {
  sectionTitles: {
    about: "About",
    experience: "Experience",
    knowledge: "Knowledge",
    contact: "Contact",
  },
  aboutMe: `Hi, I’m Izam Morales Muñoz, a full stack developer. I have three years of work experience in web development, along with two years of study in the field and one year of specialization in artificial intelligence. I’m passionate about creating innovative solutions by combining design, functionality, and advanced technology. I’m ready to take on new challenges and continue growing as a professional.`,
  experience: {
    begin: {
      title: "Beginning",
      date: "2022-2023",
      text: "I studied programming for two years at IES Zaidín Vergeles, where I gained knowledge in various technologies. I learned HTML for web structure, Java for object-oriented programming, and JavaScript to add interactivity. I also worked with databases, learning both SQL and NoSQL. \n \n During this time, I explored tools like Docker for containerization and application deployment, as well as PHP and its framework Laravel, which helped me efficiently develop web applications. Lastly, I lear ned to use WordPress to create and customize websites. This period was crucial in laying the foundation for my programming career.",
    },
    trainee: {
      title: "Trainee",
      date: "2023 (April - June)",
      text: "During my three-month professional internship at Kyndryl, I gained key skills by working as part of a team and collaborating in a professional environment. I learned about Linux system administration, strengthening my technical knowledge, and developed an automation application using Python.",
    },
    educa: {
      title: "Junior Developer",
      date: "2023 - 2025",
      text: "I started my professional career at Educa Edtech Group in 2023, where I continue to grow professionally. During this time, I have significantly enhanced my skills in Java, JavaScript, Git, Python, CSS, VBA Word and other tools, applying them to diverse and challenging projects.",
    },
    nttdata: {
      title: "Full Stack Developer",
      date: "2025 - Actual",
      text: "Driven by my ambition and my constant desire to grow as a software developer, I decided to take a step forward in my career and join NTT DATA as a Full Stack Developer. I am currently working on a project where the backend is developed in Java and the frontend is built with React. I feel very comfortable working with these technologies and I am always open to new challenges and learning opportunities.",
    },
    ia: {
      title: "New skills",
      date: "2024 (October - April)",
      text: "I completed a 600-hour specialization course in Artificial Intelligence, where I learned the fundamentals of artificial intelligence and big data. Throughout this training, I trained and applied machine learning models, performed data processing and analysis, and extracted actionable insights through visualizations, charts, and maps, applying these skills across various practical contexts.",
    },
  },
  skills: {
    initialMessage: "Click on a skill to learn more about my experience.",
    js: "Over 4 years of experience developing scalable web applications and backend services with JavaScript and Node.js, focusing on performance, maintainability, and clean code practices.",
    node: "More than 2 years of experience developing APIs and backend services with Node.js, working with scalable architectures, asynchronous workflows, and performance optimization.",
    docker:
      "More than 2 years of experience containerizing applications and servers with Docker, ensuring consistent environments across development and production.",
    mongo:
      "Over 2 years of experience designing flexible schemas and managing high-performance data storage solutions with MongoDB.",
    python:
      "More than 3 years of experience developing efficient applications with Python, working with data frames, automation scripts, and artificial intelligence models.",
    laravel:
      "1 year of experience using Laravel to build secure, organized, and scalable backend systems following MVC architecture.",
    r: "1 year of experience applying R for data cleaning, statistical analysis, predictive modeling, and advanced data visualization.",
    hadoop:
      "1 year of experience working with Hadoop ecosystems to process large volumes of distributed data efficiently.",
    css: "Over 4 years of experience designing responsive, modern, and visually consistent user interfaces using CSS.",
    java: "More than 4 years of experience developing robust desktop applications and web servers using Java.",
    react:
      "2 years of experience building dynamic, component-based web applications with React, focused on performance and user experience.",
    git: "Over 4 years of experience managing version control, branching strategies, and collaborative workflows using Git.",
  },
  contact: {
    name: "Name",
    email: "Email",
    message: "About",
    send: "Send",
    sending: "Sending...",
    fieldsError: "Please complete all fields.",
    nameError: "Name must be at least 2 characters long.",
    emailError: "Please enter a valid email address.",
    messageError: "Message must be at least 10 characters long.",
    success: "Email sent successfully!",
    error: "Error sending email: ",
  },
  footer: {
    explore: "Explore",
    home: "Home",
    legal: "Legal",
    terms: "Terms",
    privacy: "Privacy",
    cookies: "Cookies",
    email: "Email",
    linkedin: "LinkedIn",
    github: "GitHub",
    copyright: "© 2025 Izam Morales Muñoz, All Rights Reserved"
  },
  privacyPolicy: {
    title: "Privacy Policy",
    lastUpdated: "Last updated: January 2026",
    introduction: "This Privacy Policy describes how your personal data is collected, used, and protected when you use this personal website.",
    responsible: {
      title: "1. Data Controller",
      content: "The controller of your personal data is:",
      name: "Izam Morales Muñoz",
      email: "izamm1610@gmail.com"
    },
    dataCollected: {
      title: "2. Data Collected",
      content: "This website collects only the following personal data through the contact form:",
      items: [
        "Name",
        "Email address",
        "Message or inquiry"
      ]
    },
    purpose: {
      title: "3. Purpose of Processing",
      content: "The personal data collected is used exclusively for:",
      items: [
        "Responding to your inquiries and messages sent through the contact form",
        "Managing communication between you and the website controller"
      ]
    },
    legalBasis: {
      title: "4. Legal Basis",
      content: "The processing of your personal data is based on your explicit consent when submitting the contact form, in accordance with Article 6.1.a) of the General Data Protection Regulation (GDPR)."
    },
    dataSharing: {
      title: "5. Data Sharing with Third Parties",
      content: "For sending emails through the contact form, this website uses EmailJS, a third-party service provider. EmailJS acts as a data processor and is subject to its own privacy policies.",
      content2: "Your data is not shared with other third parties for commercial or marketing purposes. No international transfers of data are made outside the European Economic Area."
    },
    dataRetention: {
      title: "6. Data Retention",
      content: "Personal data will be retained only for as long as necessary to fulfill the purpose for which it was collected and, in any case, for the period established by applicable legislation."
    },
    userRights: {
      title: "7. Your Rights",
      content: "In accordance with the GDPR, you have the right to:",
      items: [
        "Access your personal data",
        "Rectify inaccurate or incomplete data",
        "Request deletion of your data",
        "Object to the processing of your data",
        "Request limitation of processing",
        "Data portability",
        "Withdraw your consent at any time"
      ],
      contact: "To exercise these rights, you can contact: izamm1610@gmail.com"
    },
    cookies: {
      title: "8. Cookies",
      content: "This website may use technical cookies necessary for the site's operation. No tracking or advertising cookies are used."
    },
    security: {
      title: "9. Security",
      content: "Appropriate technical and organizational measures are implemented to protect your personal data against unauthorized access, loss, or destruction."
    },
    changes: {
      title: "10. Changes to this Policy",
      content: "This Privacy Policy may be updated occasionally. You will be notified of any significant changes through an update to the 'Last updated' date on this page."
    },
    contact: {
      title: "11. Contact",
      content: "If you have questions or concerns about this Privacy Policy or about the processing of your personal data, you can contact:",
      email: "izamm1610@gmail.com"
    },
    backToHome: "← Back to home"
  }
};

export default en;